import { createQueryParam, createQueryFromParams } from 'modules-core/utility'
import { iTag } from './tags'
import { iElasticFilterSystem } from './elasticFilterSystem'
import { iSearchResponse } from './searchTypes'

export const SEARCH_RESULTS_PER_PAGE = 100

interface iArgs {
	elasticFilterSystem: iElasticFilterSystem
}
export const createQueryBuilder = (
	elasticFilterSystem: iElasticFilterSystem
) => {
	let page: number = 1

	const paramMap = new Map<string, string>([
		['f', 'json'],
		['q', ''],
		['tagsParam', ''],
		['pqh', ''],
		['p', ''],
		['pp', SEARCH_RESULTS_PER_PAGE.toString()],
	])

	const createSearchQuery = () => {
		const params = Array.from(paramMap.entries())
			.filter(([key, value]) => value !== '')
			.map(([key, value]) =>
				key.endsWith('Param') ? value : createQueryParam(key, value)
			)
		return createQueryFromParams(params)
	}
	const queryBuilder = {
		setCurrentSearchParams: (searchResponse: iSearchResponse) => {
			page = searchResponse.page
			paramMap.set('pqh', searchResponse.query_hash)
			paramMap.set('p', page.toString())
		},
		createNewSearchQuery: (query: string, tags: iTag[] = []) => {
			paramMap.set('q', query)
			paramMap.set('tagsParam', elasticFilterSystem.tagsToQueryParams(tags))
			paramMap.set('p', '')
			paramMap.set('pqh', '')
			return createSearchQuery()
		},
		createNextPageSearchQuery: () => {
			paramMap.set('p', (page + 1).toString())
			return createSearchQuery()
		},
	}

	return queryBuilder
}
